import { NestedDropdown, type MenuItemData } from 'mui-nested-menu';

/**
 * Элемент меню — форма сохранена от fullWeb (AppFC.kt: MenuNestedItemI),
 * чтобы рекурсивное построение из таблицы querys переносилось один в один.
 */
export interface MenuNestedItem {
  label: string;
  items?: MenuNestedItem[];
  callback?: () => void;
  sx?: Record<string, unknown>;
}

/** Палитра подменю из fullWeb (MenuNestedItem: color #0033cc на фоне #c6ecc6). */
/**
 * Палитра элементов меню — перенос значения по умолчанию из AppFC.kt:40-42:
 *   sx = json(color: "#0033cc", bgcolor: "#c6ecc6")
 *
 * ⚠️ Применяется ко ВСЕМ элементам, включая конечные пункты: в оригинале это
 * значение по умолчанию поля data-класса, поэтому фон #c6ecc6 получают и подменю,
 * и пункты. Если задать фон только подменю, конечные пункты окажутся белыми
 * вместо бледно-зелёных — заметное расхождение с оригиналом.
 */
const MENU_ITEM_SX = { color: '#0033cc', bgcolor: '#c6ecc6' } as const;

/** Преобразование нашего дерева в формат mui-nested-menu. */
export function toMenuItemData(item: MenuNestedItem): MenuItemData {
  return {
    label: item.label,
    sx: item.sx ?? MENU_ITEM_SX,
    ...(item.items?.length
      ? { items: item.items.map(toMenuItemData) }
      : { callback: item.callback ? () => item.callback?.() : undefined }),
  };
}

export interface NestedMenuProps {
  /** Корневой элемент меню (в fullWeb — всегда «Menu»). */
  data: MenuNestedItem;
  /** Подпись на кнопке; в fullWeb подписи нет, стиль задаётся ButtonProps. */
  label?: string;
  onOpen?: () => void;
}

export function NestedMenu({ data, label = 'MENU', onOpen }: NestedMenuProps) {
  // ButtonProps не задаём: как и в оригинале (AppFC.kt:434-437), кнопка остаётся
  // со стилями MUI по умолчанию — прозрачный фон и прописные буквы поверх панели.
  return (
    <NestedDropdown menuItemsData={toMenuItemData(data)} onClick={onOpen}>
      {label}
    </NestedDropdown>
  );
}
